import { Model, RailsFormat } from "./model";
import { Topic } from "./topic";
import { MatrixClass } from "./matrix-class";

export class Course extends Model implements RailsFormat {

  static subjectStrings: string[] =
    ["Biology", "Physics", "Chemistry", "Science", "Math", "English"]

  static FACULTIES: any = {
    0: "Mathematics",
    1: "Science",
    2: "English"
  }

  constructor(
    public id?: number,
    public subjectCode: string = "",
    public code: string = "",
    public name: string = "",
    public humanised: string = "",
    public grade: number = 0,
    public doublePeriod: boolean = false,
    public cost: number = 0,
    public color: string = null,
    public faculty: number = null,

    public isConfirmingRemove: boolean = false,

    public topics: Topic[] = [],
  ) {
    super()
  }

  static clone(obj: any) {
    const course: Course = new this()

    if (obj.id) { course.id = obj.id }
    if (obj.subjectCode) { course.subjectCode = obj.subjectCode }
    if (obj.humanised) { course.humanised = obj.humanised }
    if (obj.code) { course.code = obj.code }
    if (obj.name) { course.name = obj.name }
    if (obj.grade) { course.grade = obj.grade }
    if (obj.doublePeriod) { course.doublePeriod = obj.doublePeriod }
    if (obj.cost) { course.cost = obj.cost }
    if (obj.color) { course.color = obj.color }
    if (obj.faculty) { course.faculty = obj.faculty }

    if (obj.isConfirmingRemove) { course.isConfirmingRemove = obj.isConfirmingRemove }

    if (obj.topics && obj.topics.length > 0) {
      obj.topics.forEach((t: any) => {
        course.topics.push(Topic.clone(t))
      })
    }

    return course
  }

  serializeForRails() {
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/course.ts